module.exports = __webpack_public_path__ + "img/5.0c459dd4.webp";